import { render, staticRenderFns } from "./embedPage.vue?vue&type=template&id=7b689117&scoped=true&"
import script from "./embedPage.vue?vue&type=script&lang=js&"
export * from "./embedPage.vue?vue&type=script&lang=js&"
import style0 from "./embedPage.vue?vue&type=style&index=0&id=7b689117&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b689117",
  null
  
)

export default component.exports